import { PaginationProps, useTheme, Pagination as MuiPagination, useMediaQuery } from '@mui/material';
import React, { useMemo } from 'react';

export function Pagination(props: PaginationProps) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const defaultProps = useMemo(
        () =>
            isSmall
                ? {
                      boundaryCount: 0,
                      siblingCount: 0,
                  }
                : {},
        [isSmall],
    );
    return <MuiPagination {...defaultProps} {...props} />;
}
